export {
  RadioAlignment,
  RadioComponent,
  RadioOptionItem,
  RadioSize,
} from './radio.component';

// FIXME: T63333 Remove RadioComponent
